import { BLOQUE, OPTION, SANS_SUITE, ANNULATION } from '@/configuration/optionConf';
import {
  BLOQUE as BLOQUE_DEVIS,
  OPTION as OPTION_DEVIS,
  SANS_SUITE as SANS_SUITE_DEVIS,
  ANNULATION as ANNULATION_DEVIS,
} from '@/configuration/optionBlocage';
import { putOpportunite } from '@/api/opportunite/index';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import AjoutPdfOpp from '@/services/devis/ajoutPdfOpp';
import gestionErreur from '@/services/general/gestionErreur';
import { insertPieceJointe, updatePieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import { GetDevisById } from '@/api/devis';

export function creerDevisOuNon(produits) {
  let tempo = false;
  produits.reseauxTempo.forEach(res => {
    if (res.extensionOpportunite.demande) tempo = true;
  });
  return tempo;
}

export function choixEtatSouhaite(demande) {
  if (demande === OPTION) {
    return OPTION_DEVIS;
  }
  if (demande === BLOQUE) {
    return BLOQUE_DEVIS;
  }
  if (demande === SANS_SUITE) {
    return SANS_SUITE_DEVIS;
  }
  if (demande === ANNULATION) {
    return ANNULATION_DEVIS;
  }
  return null;
}

export function validFacesReseauxTempo(reseauxTempo) {
  const valid = [];
  reseauxTempo.forEach(res => {
    const facesSelectionnees = res.listeFaces
      .filter(fac => fac.selected === true).length;
    valid.push(!(facesSelectionnees > res.extensionOpportunite.facesSouhaitees));
  });
  if (valid.includes(false)) {
    gestionErreur(reseauxTempo.length > 1
      ? 'Dans un des réseau tempos, le nombre de faces sélectionnées est supérieur au nombre de faces proposées'
      : 'Le nombre de faces sélectionnées est supérieur au nombre de faces proposées');
  }
  return valid.every(v => v);
}

export const TAILLE_PJ_LIMITE = 10 * 1024 * 1024;

export function addDataDevisToOpp(opp, devis, forDetailOpp) {
  opp.data.produits.reseauxTempo.forEach(res => {
    if (res.extensionOpportunite.demande) {
      const anneeSemaine = getAnneeSemaine(
        res.extensionOpportunite.annee,
        res.extensionOpportunite.semaine,
      );
      const ligneReseauTempo = devis.lignesCommande
        .find(ligne => ligne.produitId === res.num
              && ligne.ligneReseau.anneeSemaine.toString() === anneeSemaine);
      if (ligneReseauTempo) {
        res.extensionOpportunite.referenceVentePartielle =
          !ligneReseauTempo.ligneReseau.lignesCmdSelProduits[0] ? null
            : ligneReseauTempo.ligneReseau.lignesCmdSelProduits[0].referenceVentePartielle;
        res.extensionOpportunite.dateEtatObtenu = ligneReseauTempo.dateEtatObtenu;
        res.extensionOpportunite.dateEtatSouhaite = ligneReseauTempo.dateEtatSouhaite;
        res.extensionOpportunite.idLigneDeCommande = ligneReseauTempo.id;
        res.extensionOpportunite.facesDevisIds = ligneReseauTempo.ligneReseau.lignesCmdSelProduits
          .map(face => face.produitId);
        if (forDetailOpp) {
          res.extensionOpportunite.etatObtenu = ligneReseauTempo.etatObtenu;
        }
      }
    }
  });
}

export async function updateOppWithDevis(devis, opp, isValid) {
  opp.data.devisObject = {
    id: devis.id,
    code: devis.code,
    etat: devis.etat,
  };
  if (isValid) opp.data.valider = true;
  if (creerDevisOuNon(opp.data.produits)) {
    addDataDevisToOpp(opp, devis);
  }
  try {
    await putOpportunite(opp.id, opp);
  } catch (e) {
    gestionErreur('Erreur lors de la modifiation de l\'opportunité', e);
    throw e;
  }
}

export async function addOppPdfToDevis(isCreerDevis, opp, devisId) {
  const pdf = await AjoutPdfOpp(opp.url);
  if (pdf[0].size < TAILLE_PJ_LIMITE) {
    if (isCreerDevis) await insertPieceJointe(pdf, devisId, 'Devis');
    else await updatePieceJointe(pdf, devisId, 'Devis');
  } else {
    gestionErreur('La taille du fichier pdf de l\'opportunité dépasse la taille maximale, le fichier ne sera pas ajouté en pièce jointe au devis');
  }
}

export async function getDataDevisToOpp(opp) {
  if (!opp.data.devisObject) return opp;
  try {
    const devis = (await GetDevisById(opp.data.devisObject.id)).data.result;
    addDataDevisToOpp(opp, devis, true);
    return opp;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      if (error.response.data.error.message.indexOf('Il n\'y a pas d\'entité DevisCommandeEntity avec id') === 0) {
        opp.data.produits.reseauxTempo.forEach(o => {
          o.extensionOpportunite.etatObtenu = 'Devis supprimé';
        });
      }
    }
    return opp;
  }
}



// WEBPACK FOOTER //
// ./src/services/panier/devis.js